module.exports = __webpack_public_path__ + "static/media/io.1734998d.svg";